import { modules } from './modules'
import { common } from '../../common'
import translate from '../../../../utils/translate'
/**
 * @fileOverview Clubhouse (/team/1/england) page parser functions
 */

/**
 * Rugby Clubhouse data parsers
 * @type {Object}
 */
export const clubhouse = {
  modules : modules,
  /**
   * [getMetaData updates meta data]
   * @param  {[type]} edition [editions data]
   * @param  {[type]} params   [normalized params]
   * @param  {[type]} team     [team information]
   * @param  {[type]} location [location information]
   * @return {[type]}          [returns object]
   */
  getMetaData: function (edition={}, params={}, team={}) {
    let title = ''
    let description = ''
    let keywords = ''

    if(typeof team !== 'undefined') {
      if(team.hasOwnProperty('name') === true) {
        let team_name = team.name ? team.name : ''
        let team_logo = team.logoLarge ? team.logoLarge : ''
        let slug = team.displayName ? team.displayName : team_name
        slug = common.getSafeSlug(slug)

        let canonical = common.createCanonical(edition, params, null, slug)

        if ( params.sport === 'rugby' && params.slug ) {
          let titleTransObj = {
            key : 'meta.title.rugby.clubhouse',
            team : team_name
          }
          let descriptionTransObj = {
            key : 'meta.description.rugby.clubhouse',
            team : team_name
          }
          let keywordsTransObj = {
            key : 'meta.keywords.rugby.clubhouse',
            team : team_name
          }
          title = translate(edition, titleTransObj) || ''
          description = translate(edition, descriptionTransObj) || ''
          keywords = translate(edition, keywordsTransObj) || ''
        }

        return {
          slug: slug,
          title: title || `${team_name} News and Scores - ESPN`,
          description: description || `Get the latest ${team_name} news, scores, stats, standings, rumours, and more from ESPN.`,
          keywords: keywords || `${team_name}, rugby, rugby union, scores, news, schedule, highlights`,
          website: 'article',
          canonical: canonical,
          image: team_logo
        }
      }
    }
  }
}

export default clubhouse



// WEBPACK FOOTER //
// ../app/lib/transform/parsers/rugby/clubhouse/index.js